import React, {Fragment, Component} from 'react';
import {
    Input,
    InputGroup,
    InputGroupAddon,
    Button,
    Col, Row,
    Label
} from 'reactstrap'
import {connect} from 'react-redux';
import autobind from 'autobind-decorator'
import { BaseUrl } from '../../BaseUrl/BaseUrl';
import { sendMessage } from '../../apa/actions';

@connect(
    state => {
        return {
            customers: state.customers,
            auth: state.apa
        }
    },
    dispatch => {
        return {
            sendMessage: (message, type) => dispatch(sendMessage({ text: message, color: type }))
        }
    }
)
export default class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null
        };
    }

    @autobind
    save() {
        this.props.save();
    }

    @autobind
    toggleAnswers() {
        this.props.setOpenQuestion(this.props.dkey)
    }

    @autobind
    updateQuestion(e) {
        const {value, name} = e.target;
        const {question, updateQuestion} = this.props;
        updateQuestion({
            ...question,
            [name]: value
        })
    }

    @autobind
    deleteQuestion() {
        const { deleteQuestion } = this.props;
        deleteQuestion();
    }

    @autobind
    addNewAnswer() {
        const {question, updateQuestion} = this.props;
        const {answers} = question;
        updateQuestion({
            ...question,
            answers: [...answers, {
                text: 'Neue Antwort',
                correct: true,
                idx: answers.length + 1
            }]
        })
    }

    @autobind
    deleteAnswer(answer) {
        const answerList = this.props.question.answers.filter(
            aa => aa.idx !== answer.idx
        )
        this.props.updateQuestion({
            ...this.props.question,
            answers: answerList.map(
                (answer, idx) => ({
                    ...answer,
                    idx: idx + 1
                })
            )
        })
        this.save()
    }

    @autobind
    updateAnswerText(answer, e) {
        const answerList = this.props.question.answers.map(
            aa => aa.idx === answer.idx ? {...answer, text: e.target.value} : aa
        )
        this.props.updateQuestion({
            ...this.props.question,
            answers: answerList
        })
    }

    @autobind
    toggleAnswerCorrectness(answer, correct) {
        const answerList = this.props.question.answers.map(
            aa => aa.idx === answer.idx ? {...answer, correct: correct} : aa
        )
        this.props.updateQuestion({
            ...this.props.question,
            answers: answerList
        })
        this.save()
    }

    @autobind
    handleUpload(){
        const headers = {
            Authorization: `Token ${this.props.auth.token}`,
        };
        const body = new FormData()
        body.append('file', this.state.file)
        body.append('question', this.props.question.idx)
        fetch(`${BaseUrl}/api/trainings/${this.props.trainingId}/upload-additional-information-file/`, {headers, method: 'POST', body})
        .then(res => {
            if (!res.ok) {
                throw new Error('Error occurred.');
            }
            return res.json();
        })
        .then((res) => {
            this.props.sendMessage('Änderungen gespeichert.', 'success');
            this.setState({
                file: null,
            })
            window.location.reload()
        })
        .catch(() => this.props.sendMessage('Fehler aufgetreten.', 'danger'));
    }

    render() {
        const {question} = this.props;
        const isOpen = this.props.dkey === this.props.openQuestion();
        return (
            <Fragment>
                <InputGroup className="d-flex justify-content-between align-items-center">
                <   InputGroupAddon addonType='prepend'>
                        <Button color='primary' onClick={this.toggleAnswers}>
                            {this.props.index + 1}.
                        </Button>
                    </InputGroupAddon>
                    <InputGroupAddon addonType='append'>
                        <Button color='danger' onClick={this.deleteQuestion}>
                            <i className={'fa fa-trash'}> </i>
                        </Button>
                    </InputGroupAddon>
                </InputGroup>
                <Label style={{paddingTop: '10px'}} for={`questionField_${this.props.index}`}><strong>Frage:</strong></Label>
                <Input
                    type="textarea"
                    value={question.text}
                    name='text'
                    onChange={this.updateQuestion}
                    onBlur={this.save}
                />
                <Label for={`alternativeField_${this.props.index}`}><strong>Erklärung:</strong></Label>
                <Input
                    type="textarea"
                    id={`alternativeField_${this.props.index}`}
                    placeholder="Geben Sie einen alternativen Text ein"
                    value={question.alternative || ''}
                    onChange={(e) => {
                        const updatedQuestion = {
                            ...question,
                            alternative: e.target.value
                        };
                        this.props.updateQuestion(updatedQuestion);
                    }}                        
                    onBlur={this.save}
                />
                <div style={{
                        border: '1px solid black',
                        padding: '8px',
                        marginTop: '4px'
                    }}>
                    <Label for={`additionalInformationFile_${this.props.index}`}><strong>Zusätzliche Informationsdatei:</strong></Label>
                    {
                        question && question.additional_information_link && (
                            <div style={{
                                marginBottom: '4px'
                            }}>
                                <a href={BaseUrl + question.additional_information_link}>{BaseUrl + question.additional_information_link}</a>
                            </div>
                        )
                    }
                    <Input
                        id={`additionalInformationFile_${this.props.index}`}
                        type="file"
                        accept="application/pdf"
                        onChange={(event) => this.setState({file: event.target.files[0]})}
                    />
                    <div className="d-flex justify-content-end">
                        <Button
                            color='primary'
                            disabled={!this.state.file}
                            onClick={this.handleUpload}
                        >
                            Hochladen
                        </Button>
                    </div>
                </div>
                {
                    isOpen &&
                    <div>
                        <Row>
                            <Col lg={1}>
                                <Label><strong>Punkte:</strong></Label>
                                <Input type='number' name='points' value={question.points} onChange={this.updateQuestion} onBlur={this.save}/>
                            </Col>
                        </Row>
                        <Label><strong>Antworten:</strong></Label>
                        <br/>
                        <Button color={'primary'} onClick={this.addNewAnswer}>
                            <i className={'fa fa-plus'}> </i> Antwort hinzufügen
                        </Button>
                        <br/>
                        {
                            question.answers.map((answer, idx) => (
                                <InputGroup key={`answer_${idx}`} style={{'marginTop': '1em'}}>
                                    <InputGroupAddon addonType='prepend'>
                                        <Button color='primary'>
                                            {answer.idx}.
                                        </Button>
                                    </InputGroupAddon>
                                    <Input type="text" value={answer.text} name='text' onChange={(e) => this.updateAnswerText(answer, e)} onBlur={this.save}/>
                                    <InputGroupAddon addonType='append'>
                                        {answer.correct &&
                                        <Button color='success' onClick={() => this.toggleAnswerCorrectness(answer, false)}>
                                            Richtig
                                        </Button>
                                        }
                                        {!answer.correct &&
                                        <Button color='warning' onClick={() => this.toggleAnswerCorrectness(answer, true)}>
                                            Falsch
                                        </Button>
                                        }
                                        <Button color='danger' onClick={() => this.deleteAnswer(answer)}>
                                            <i className={'fa fa-trash'}> </i>
                                        </Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            ))
                        }
                    </div>
                }
            </Fragment>
        )
    }
}
